<template>
  <div>
    <a href="#" :aria-label="$t('История') + ': ' + statusName" @click.prevent="historyDialog = true">{{ statusName }}</a>
    <v-dialog v-model="historyDialog" max-width="940">
      <v-card class="modal modal-user-access-journal">
        <div class="modal-head">
          {{ $t('История') }}
          <v-btn color="modal-close" :aria-label="$t('Закрыть')" @click.native="historyDialog = false">
            <span class="pro-icon-close1" aria-hidden="true"></span>
          </v-btn>
        </div>
        <div class="modal-body">
          <div class="table-overflow">
            <table>
              <thead>
              <tr>
                <td>
                  {{ $t('Дата') }}
                </td>
                <td>
                  {{ $t('Статус') }}
                </td>
                <td>
                  {{ $t('Пользователь') }}
                </td>
                <td>
                  {{ $t('Причина') }}
                </td>
                <td>
                  {{ $t('Комментарии') }}
                </td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="history in histories"
                  :key="history.id"
                  :class="history.id"
              >
                <td class="td-date">{{ new Date(history.created_date) | dateFormat('DD.MM.YYYY')}}</td>
                <td>{{ history.appeal_status.transName }}</td>
                <td>
                  <span v-if="history.user_id">
                    {{ history.user_id.nick_name }}
                  </span>
                </td>
                <td>
                  <span v-if="history.reason_reject_appeal">
                    {{ history.reason_reject_appeal.transName }}
                  </span>
                </td>
                <td>{{ history.note }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  export default {
    props: {
      histories: Array,
      statusName: String,
    },
    data() {
      return {
        historyDialog: false
      }
    }
  }
</script>
